const EMPTY = {};
/**
 * Formats numerical values.
 * @param {Number} value - int value to be formatted.
 * @param {Number} options.unset - Value to return if the the value is not an int.
 * @param {Object} options.lookup - mapping of value to return value.
 */
function format(value, options) {
  // Get parameters
  const {
    unset = '',
    localize,
    prefix,
    suffix,
    mapping = EMPTY
  } = options || EMPTY;

  // Validate parameters
  if (typeof value !== 'number') {
    return [unset];
  }
  let v = value;
  if (mapping[value] !== undefined) {
    v = mapping[value];
  } else if (localize && typeof v === 'number') {
    v = v.toLocaleString();
  }
  if (prefix) {
    if (suffix) {
      return [prefix + v + suffix];
    }
    return [prefix + v];
  }
  if (suffix) {
    return [v + suffix];
  }
  return [v];
}
export default {
  format
};